




import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class ProductAddListIframe extends Vue {
  private get remoteSrc() {
    const queryString = new URLSearchParams({ serviceType: 'PREMIUM' }).toString();
    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/product/management/choose-type?' + queryString;
  }
}
